import { MDBCol } from 'mdb-react-ui-kit'
import React from 'react'

const PageTitle = ({logo}) => {
  return (
        <MDBCol className="col-sm-12 d-flex flex-column justify-content-center align-items-center">
            <div id="image03" className="image my-4"><span className="frame"><img src={logo} alt="" /></span></div>
            <h1 id="text03" className="mb-4">title</h1>
            <div className="divider-small mt-2 mb-4"></div>
            <p className="intro-paragraphs-text">Ipsum gravida sed feugiat amet tempus</p>
            <div className="divider mt-4 mb-3"></div>
        </MDBCol>
  )
}

export default PageTitle